import React from 'react';
import {Flex} from '@chakra-ui/react';
import {TextG14} from '../../../components/typography';

const ITEMS = [
  'New perks and offers released next month',
  'Exclusive access to Walkabout events & member experiences nearby',
  'Early access to listings of apartments available for rent before they hit the market',
];

const XGlyph = () => (
  <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
    <path
      d="M6 6l12 12M18 6L6 18"
      stroke="#5A5A5A"
      strokeWidth={2.4}
      strokeLinecap="round"
    />
  </svg>
);

const LossList = () => (
  <Flex direction="column" gap={3}>
    {ITEMS.map((item) => (
      <Flex key={item} gap={3} align="center">
        <Flex flexShrink={0} mt="2px">
          <XGlyph />
        </Flex>
        <TextG14 color="#202020" lineHeight="22px">
          {item}
        </TextG14>
      </Flex>
    ))}
  </Flex>
);

export default LossList;
